var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCalendar24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_calendar24x24",
    transform: "translate(-3 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M35.555,1.6h-.889V0H32.889V1.6H25.777V0H24V1.6h-.889a1.874,1.874,0,0,0-1.254.469A1.515,1.515,0,0,0,21.342,3.2l-.009,11.2A1.7,1.7,0,0,0,23.111,16H35.555a1.7,1.7,0,0,0,1.778-1.6V3.2A1.7,1.7,0,0,0,35.555,1.6Zm0,12.8H23.111V5.6H35.555Z",
    transform: "translate(-21.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M123.464,192.949l-.936-.949-4.308,4.368-1.872-1.9-.936.949,2.807,2.847Z",
    transform: "translate(-111.465 -185.261)"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCalendar24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_calendar24x24.2464b47569f9c9e7cf36084772524bbf.svg";